import { inject, Injectable } from '@angular/core';
import { type Incident } from '@td/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IncidentService {
  private readonly http = inject(HttpClient);

  load(lang?: string): Observable<Incident> {
    /**
     * Should remain as let because this class is immutable.
     * Details: {@link https://angular.dev/api/common/http/HttpParams#description}
     */
    let params = new HttpParams();
    if (lang) {
      params = params.set('lang', lang);
    }

    return this.http.get<Incident>(`api/v1/tickets/workup/current`, { params });
  }
}
